import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert-component relative bg-red-100 text-red-800 border border-red-300 rounded-md p-4 mb-4 shadow-md"
}
const _hoisted_2 = { class: "font-medium" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      ($setup.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _createCommentVNode(" Progress Bar "),
            _createElementVNode("div", {
              class: "absolute bottom-0 left-0 h-1 bg-red-400 transition-all duration-100",
              style: _normalizeStyle({ width: $setup.progressWidth + '%' })
            }, null, 4 /* STYLE */),
            _createCommentVNode(" Close Button "),
            _createElementVNode("button", {
              onClick: $setup.dismiss,
              class: "absolute top-2 right-3 text-red-800 hover:text-red-600 text-xl leading-none focus:outline-none",
              "aria-label": "Close"
            }, " × ")
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }))
}